export default __webpack_public_path__ + "static/media/vegan-pals.a366ee2e.png";